import React, { useState } from 'react'
import emailjs from '@emailjs/browser'
import myFuelLogoDesktop from "../assets/images/myFuelLogo-desktop.png";
import Logo from "../assets/images/Logo.png";
import myFuelLogo from "../assets/images/myfuel-logo.png";
import diagonalArrow from "../assets/images/diagonal-arrow-right-up.svg";
import { Link } from 'react-router-dom';

const Footer = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  const handleSubscribe = (e) => {
    e.preventDefault();
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setMessage('Please enter a valid email address.');
      setTimeout(() => setMessage(''), 3000);
      return;
    }
    const templateParams = {
      from_name: email,
      to_name: 'Newsletter Subscriber',
      message: 'New newsletter subscription: ' + email,
    };
    emailjs
      .send('service_lfor4gp', 'template_58rwkfv', templateParams, '_R87prW-S6gzMeyWk')
      .then(() => {
        setMessage('Subscribed successfully!');
        setEmail('');
        setTimeout(() => setMessage(''), 3000);
      })
      .catch(() => {
        setMessage('Something went wrong. Please try again.');
        setTimeout(() => setMessage(''), 3000);
      });
  };

  return (
    <div className="col-12 d-flex flex-column align-items-center Width1440">
      <footer className="col-12 col-md-12 py-[16px] md:py-[64px]  px-1 pb-0">
        <div className="d-flex p-0 justify-content-between flex-wrap">
          <div className='col-12 col-sm-3 col-md-5 mb-4 col-md-2'>
            <img
              src={myFuelLogo}
              alt="MyFuelAi"
              width={160}
            />
            <div className='col-12 d-none d-md-block md:mt-[50px]'>
              <p className='text-dark text-[16px] font-[400]'>Subscribe to get the latest insights </p>
              <form onSubmit={handleSubscribe} className='d-flex col-10'>
                <input
                  id="newsletter1"
                  type="email"
                  className="footer-input bg-white text-muted p-2"
                  placeholder="Enter your email here"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
                <button className='footer-btn mx-2' type='submit'>
                  <img className="diagonalArrowRightUpIcon" alt="" src={diagonalArrow} />
                </button>
              </form>
              {message && <p className='text-dark text-[14px] mt-2'>{message}</p>}
            </div>
          </div>

          <div className="col-12 col-sm-3 col-md-2 mb-3">
            <h5 className='text-muted text-[18px] mb-2'>Company</h5>
            <ul className="nav flex-column gap-2 mt-[18px]">
              {/* <li className="nav-item mb-2 fs-7">
                <a href="/solutions" className="nav-link p-0 text-dark mx-1">
                  Solutions
                </a>
              </li> */}
              <li className="nav-item mb-2 ">
                <a href="/#disruption" className=" p-0 text-dark mx-1  text-[18px] font-[500]">
                  Features
                </a>
              </li>
              <li className="nav-item mb-2 fs-7">
                <a href="/platform" className=" p-0 text-dark mx-1  text-[18px] font-[500]">
                  How It Works
                </a>
              </li>
              <li className="nav-item mb-2 fs-7">
                <a href="/aboutus" className=" p-0 text-dark mx-1  text-[18px] font-[500]">
                  Our Story
                </a>
              </li>
              <li className="nav-item mb-2 fs-7">
                <a href="/contactus" className=" p-0 text-dark mx-1  text-[18px] font-[500]">
                  Talk to Us
                </a>
              </li>
              <li className="nav-item mb-2 fs-7">
                <a href="/#faq" className=" p-0 text-dark mx-1  text-[18px] font-[500]">
                  F.A.Q
                </a>
              </li>
            </ul>
          </div>

          <div className="col-12 col-sm-3 col-md-2 mb-3">
            <h5 className='text-muted text-[18px]'>Social networks</h5>
            <ul className="col-12 nav flex-column gap-2 mt-3">
              {/* <li className="d-flex nav-item mb-2 ">
                <a href="#" className="p-0 text-dark footer-text">
                  Facebook
                </a>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                  <path fillRule="evenodd" clipRule="evenodd" d="M17.9932 7.57048C17.9932 7.02148 17.5493 6.57448 16.9993 6.57148L9.00625 6.52148H9.00025C8.45025 6.52148 8.00425 6.96548 8.00025 7.51548C7.99625 8.06748 8.44125 8.51848 8.99425 8.52148L14.5522 8.55648L6.29325 16.8145C5.90225 17.2055 5.90225 17.8385 6.29325 18.2285C6.48825 18.4245 6.74425 18.5215 7.00025 18.5215C7.25625 18.5215 7.51225 18.4245 7.70725 18.2285L15.9952 9.94048L16.0002 15.5225C16.0002 16.0745 16.4482 16.5215 17.0002 16.5215H17.0013C17.5533 16.5215 18.0002 16.0725 18.0002 15.5205L17.9932 7.57048Z" fill="#1D2023" />
                </svg>
              </li> */}
              <li className="d-flex nav-item mb-2">
                <a href="https://www.linkedin.com/company/myfuel-ai/posts/?feedView=all" target="_blank" rel="noreferrer" className=" p-0 text-dark   text-[18px] font-[400] ">
                LinkedIn
                </a>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                  <path fillRule="evenodd" clipRule="evenodd" d="M17.9932 7.57048C17.9932 7.02148 17.5493 6.57448 16.9993 6.57148L9.00625 6.52148H9.00025C8.45025 6.52148 8.00425 6.96548 8.00025 7.51548C7.99625 8.06748 8.44125 8.51848 8.99425 8.52148L14.5522 8.55648L6.29325 16.8145C5.90225 17.2055 5.90225 17.8385 6.29325 18.2285C6.48825 18.4245 6.74425 18.5215 7.00025 18.5215C7.25625 18.5215 7.51225 18.4245 7.70725 18.2285L15.9952 9.94048L16.0002 15.5225C16.0002 16.0745 16.4482 16.5215 17.0002 16.5215H17.0013C17.5533 16.5215 18.0002 16.0725 18.0002 15.5205L17.9932 7.57048Z" fill="#1D2023" />
                </svg>
              </li>
            </ul>
          </div>

          <div className="col-12 col-sm-3 col-md-2 mb-3">
            <h5 className='text-muted mb-3 text-[18px] mx-md-2'>Contact Us</h5>
            <ul className="col-12 nav flex-column">
              <li className="d-flex nav-item mb-2  gap-3 ">
                <svg className='mar-l' xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                  <g clipPath="url(#clip0_11865_21863)">
                    <path d="M12 13.2715C13.6569 13.2715 15 11.9283 15 10.2715C15 8.61463 13.6569 7.27148 12 7.27148C10.3431 7.27148 9 8.61463 9 10.2715C9 11.9283 10.3431 13.2715 12 13.2715Z" stroke="#6245D8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M19.5 10.2715C19.5 17.0215 12 22.2715 12 22.2715C12 22.2715 4.5 17.0215 4.5 10.2715C4.5 8.28236 5.29018 6.37471 6.6967 4.96818C8.10322 3.56166 10.0109 2.77148 12 2.77148C13.9891 2.77148 15.8968 3.56166 17.3033 4.96818C18.7098 6.37471 19.5 8.28236 19.5 10.2715Z" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                  </g>
                  <defs>
                    <clipPath id="clip0_11865_21863">
                      <rect width="24" height="24" fill="white" transform="translate(0 0.521484)" />
                    </clipPath>
                  </defs>
                </svg>
                <a href="#" className="nav-link p-0 text-dark text-[18px] font-[400]">
                  99 South Almaden Boulevard<br />
                  Suite 600<br />
                  San Jose, California 95113
                </a>
              </li>
              <li className="d-flex nav-item mb-2 gap-3">
                <svg className='mar-l' xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                  <g clipPath="url(#clip0_11865_21869)">
                    <path d="M14.25 5.02148C15.5114 5.35366 16.6621 6.01469 17.5844 6.93705C18.5068 7.85942 19.1678 9.01007 19.5 10.2715" stroke="#6245D8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M13.5 8.02148C15.0488 8.43586 16.0856 9.47273 16.5 11.0215" stroke="#6245D8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M14.6616 14.8972C14.7654 14.8281 14.8849 14.786 15.0091 14.7747C15.1334 14.7634 15.2585 14.7833 15.3731 14.8325L19.7944 16.8135C19.9434 16.8771 20.0677 16.9874 20.1489 17.1276C20.23 17.2679 20.2635 17.4307 20.2444 17.5916C20.0987 18.6801 19.5627 19.6786 18.736 20.4015C17.9093 21.1244 16.8482 21.5224 15.75 21.5216C12.3685 21.5216 9.12548 20.1783 6.73439 17.7872C4.3433 15.3961 3 12.1531 3 8.77159C2.99916 7.6734 3.3972 6.61229 4.12009 5.78559C4.84298 4.95888 5.84152 4.42286 6.93 4.27721C7.09091 4.2581 7.25368 4.29161 7.39395 4.37273C7.53422 4.45385 7.64444 4.57821 7.70813 4.72721L9.68906 9.15221C9.73774 9.26586 9.75756 9.38979 9.74676 9.51295C9.73596 9.63611 9.69489 9.7547 9.62719 9.85815L7.62375 12.2403C7.55269 12.3476 7.51066 12.4714 7.50179 12.5997C7.49291 12.7281 7.51749 12.8565 7.57313 12.9725C8.34844 14.5597 9.98906 16.1806 11.5809 16.9485C11.6975 17.0039 11.8266 17.0279 11.9553 17.0182C12.084 17.0085 12.208 16.9654 12.315 16.8931L14.6616 14.8972Z" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                  </g>
                  <defs>
                    <clipPath id="clip0_11865_21869">
                      <rect width="24" height="24" fill="white" transform="translate(0 0.521484)" />
                    </clipPath>
                  </defs>
                </svg>
                <a href="#" className=" p-0 text-dark  text-[18px] font-[400]">
                  +1 530-551-7009
                </a>
              </li>
              <li className="d-flex nav-item mb-2 gap-3">

                <a href="mailto:contactus@myfuel.ai" className=" p-0 text-dark  text-[18px] font-[400]">
                  contactus@myfuel.ai
                </a>
              </li>

            </ul>
          </div>

          <div className='col-12 col-md-2 d-sm-block d-md-none '>
            <p className='text-dark'>Subscribe to get the latest insights </p>
            <form onSubmit={handleSubscribe} className='d-flex'>
              <input
                id="newsletter2"
                type="email"
                className="footer-input bg-white text-muted"
                placeholder="Enter your email here"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <button className='footer-btn mx-2' type='submit'>
                <img className="diagonalArrowRightUpIcon" alt="" src={diagonalArrow} />
              </button>
            </form>
            {message && <p className='text-dark text-[14px] mt-2'>{message}</p>}
          </div>

        </div>

        <div className="d-flex flex-column flex-md-row justify-content-md-between py-4 p-2 pb-1">
          <p className='text-muted text-[14px] font-[500]'> © 2025{process.env.REACT_APP_BUILD_VERSION}</p>
          <ul className="list-unstyled d-flex gap-5 ">
            <li className="text-muted text-[14px] font-[500]">
              <Link className="nav-link navbar-links" to={"/terms"}>
                <p>Terms of Service</p>
              </Link>
            </li>
            <li className="mx-3 text-muted text-[14px] font-[500]">
            <Link className="nav-link navbar-links" to={"/privacy"}>
              <p>Privacy Policy</p>
            </Link>
            </li>
          </ul>
        </div>
      </footer>
    </div>
  )
}

export default Footer